import React from 'react';

const LogoMRTPlus = ({ className = "h-12 w-auto" }) => {
  return (
    <svg 
      className={className}
      viewBox="0 0 400 200" 
      fill="none" 
      xmlns="http://www.w3.org/2000/svg"
    >
      <defs>
        <linearGradient id="blackWhiteGradient" x1="0%" y1="0%" x2="0%" y2="100%">
          <stop offset="0%" style={{ stopColor: '#1a1a1a', stopOpacity: 1 }} />
          <stop offset="100%" style={{ stopColor: '#4a4a4a', stopOpacity: 1 }} />
        </linearGradient>
        <linearGradient id="textGradient" x1="0%" y1="0%" x2="0%" y2="100%">
          <stop offset="0%" style={{ stopColor: '#2a2a2a', stopOpacity: 1 }} />
          <stop offset="100%" style={{ stopColor: '#5a5a5a', stopOpacity: 1 }} />
        </linearGradient>
      </defs>
      
      {/* Infinity symbol with network lines - similar to RT CONNECT but in grayscale */}
      {/* Left circle */}
      <path
        d="M 80 100 A 50 50 0 1 1 80 101 Z"
        fill="url(#blackWhiteGradient)"
        stroke="#1a1a1a"
        strokeWidth="2"
      />
      
      {/* Digital lines in left circle - EN BLANC */}
      <rect x="50" y="75" width="8" height="8" fill="#ffffff" />
      <rect x="62" y="75" width="20" height="8" fill="#ffffff" />
      <rect x="86" y="75" width="8" height="8" fill="#ffffff" />
      
      <rect x="45" y="95" width="8" height="8" fill="#ffffff" />
      <rect x="57" y="95" width="8" height="8" fill="#ffffff" />
      <rect x="69" y="95" width="14" height="8" fill="#ffffff" />
      <rect x="87" y="95" width="14" height="8" fill="#ffffff" />
      
      <rect x="50" y="115" width="8" height="8" fill="#ffffff" />
      <rect x="62" y="115" width="14" height="8" fill="#ffffff" />
      
      {/* Right circle */}
      <path
        d="M 180 100 A 50 50 0 1 1 180 101 Z"
        fill="url(#blackWhiteGradient)"
        stroke="#1a1a1a"
        strokeWidth="2"
      />
      
      {/* Digital lines in right circle - EN BLANC */}
      <rect x="150" y="75" width="8" height="8" fill="#ffffff" />
      <rect x="162" y="75" width="20" height="8" fill="#ffffff" />
      <rect x="186" y="75" width="8" height="8" fill="#ffffff" />
      
      <rect x="145" y="95" width="8" height="8" fill="#ffffff" />
      <rect x="157" y="95" width="8" height="8" fill="#ffffff" />
      <rect x="169" y="95" width="14" height="8" fill="#ffffff" />
      <rect x="187" y="95" width="14" height="8" fill="#ffffff" />
      
      <rect x="150" y="115" width="8" height="8" fill="#ffffff" />
      <rect x="162" y="115" width="14" height="8" fill="#ffffff" />
      
      {/* Company name MRT */}
      <text
        x="10"
        y="165"
        fontFamily="Arial, sans-serif"
        fontSize="42"
        fontWeight="bold"
        fill="url(#textGradient)"
        letterSpacing="2"
      >
        MRT
      </text>
      
      {/* Le symbole + avec cadre blanc */}
      <g transform="translate(120, 140)">
        {/* Cadre/fond blanc pour le + */}
        <rect x="-8" y="-8" width="32" height="32" fill="#ffffff" rx="4" />
        {/* Le symbole + en noir/gris */}
        <text
          x="0"
          y="20"
          fontFamily="Arial, sans-serif"
          fontSize="42"
          fontWeight="bold"
          fill="url(#textGradient)"
        >
          +
        </text>
      </g>
      
      {/* Tagline */}
      <text
        x="10"
        y="190"
        fontFamily="Arial, sans-serif"
        fontSize="16"
        fill="#5a5a5a"
        letterSpacing="1"
      >
        Excellence & Innovation
      </text>
    </svg>
  );
};

export default LogoMRTPlus;
